import { render } from "./ReviewBooking.vue?vue&type=template&id=4ffe2cb8&scoped=true"
import script from "./ReviewBooking.vue?vue&type=script&lang=js"
export * from "./ReviewBooking.vue?vue&type=script&lang=js"

import "./ReviewBooking.vue?vue&type=style&index=0&id=4ffe2cb8&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffe2cb8"]])

export default __exports__